<template>
	<div class="banner-split2-about row">
		<div class="left rwd-m-6">
			<PageTitle ch="最新消息" en="News"></PageTitle>
			<br />
			<table>
				<tr v-for="(news, key) in newsDataR.slice(0, 4)" :key="key">
					<td>
						{{ timeConvert(news.date, true) }}
						<br />{{ timeConvert(news.date, false) }}
					</td>
					<td>
						<router-link :to="'/news/' + news.id">{{ news.title }}</router-link>
					</td>
				</tr>
			</table>
			<br />
			<div class="row" align-x="right">
				<router-link
					class="row"
					align-y="center"
					to="/event/news"
					style="
						border-radius: 100px;
						background: #01b6e2;
						padding: 0.5em 2em;
						color: #fff;
					"
				>
					<span>最新消息</span>&emsp;
					<img src="@/assets/home/arrow.png" height="13" />
				</router-link>
			</div>
		</div>
		<div class="right col rwd-m-6" gutter="30">
			<h1 class="row" align-y="center" gutter="10">
				<img
					src="@/assets/home/logo.png"
					style="width: 1.5em; display: inline"
				/>
				<span>參觀資訊</span>
			</h1>
			<p>
				藝術村參訪採「預約制」，歡迎點選右上方「活動預約」並填寫表單，將有專人與您聯繫，或來電洽詢03-950-1977
				(週一至週五 09:30-17:30)
			</p>
			<p>最新、最即時的訊息，歡迎追蹤「利澤國際偶戲藝術村」各項粉絲頁！</p>
			<ul class="content community">
				<li>
					<a
						href="https://www.facebook.com/lize.puppet.art.colony/"
						target="_blank"
					>
						<img class="social" src="@/assets/btn_facebook.svg" alt="" />
					</a>
				</li>
				<li>
					<a
						href="https://www.instagram.com/lize_puppet_art_colony?igsh=MTU3ajRkeHkwNWVjcQ=="
						target="_blank"
					>
						<img class="social" src="@/assets/btn_IG.svg" alt="" />
					</a>
				</li>
				<li>
					<a
						href="https://www.youtube.com/channel/UCFJDxJMeO2aUFfyWQz2o4-w"
						target="_blank"
					>
						<img class="social" src="@/assets/btn_YT.svg" alt="" />
					</a>
				</li>
				<li>
					<a href="https://lin.ee/jcQ9zMF" target="_blank">
						<img class="social" src="@/assets/btn_line.png" alt="" />
					</a>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Slider from "@/components/slider";
import Lightbox from "vue-easy-lightbox";
import PageTitle from "@/components/page_title";
export default {
	name: "bannerSplit2About",
	data() {
		return {
			tabState: 0,
			visible: false,
			newsDataR: [],
		};
	},
	computed: {
		...mapState(["newsData"]),
	},
	watch: {
		newsData: function () {
			this.newsDataR = this.newsData.list;
		},
	},
	methods: {
		...mapActions(["getNews"]),
		switchTab: function (tab) {
			this.tabState = tab;
		},
		showMap() {
			this.visible = true;
		},
		hideMap() {
			this.visible = false;
		},
		timeConvert: function (timestamp, onlyYear) {
			let date = new Date(timestamp);
			if (onlyYear) {
				return date.getFullYear();
			} else {
				return `${date.getMonth() + 1}/${date.getDate()}`;
			}
		},
	},
	props: {
		ch: String,
		en: String,
	},
	components: {
		PageTitle,
		Slider,
		Lightbox,
		Ratio: () => import("./Ratio"),
	},
	mounted() {
		this.getNews({ offset: (1 - 1) * 10, length: 10 });
	},
};
</script>

<style lang="scss" scoped>
.col {
	padding: 0;
}
.row {
	margin: 0;
}
.left {
	padding: 3%;
	padding-top: 0;
	background-color: #edfbff;
	background-image: url("../assets/home/bg.png");
	background-position: right bottom;
	background-size: 80%;
	background-repeat: no-repeat;
	color: #000;
	padding-bottom: 300px;

	a {
		font-size: 1.2em;
		color: initial;
	}

	table {
		vertical-align: top;
		border-spacing: 1em 2em;
		border-collapse: separate;
	}
}
.right {
	padding: 3%;
	background: #062b51;
	color: #fff;
	padding-top: 50px;
	padding-bottom: 200px;
	.community {
		display: flex;
		margin-top: 0;
		margin-bottom: 40px;
		li {
			width: 37px;
			margin-left: 20px;
			img {
				width: 100%;
			}
		}
		li:first-child {
			margin-left: 0px;
		}
	}
	p {
		line-height: 1.8;
		font-size: 14px;
		font-weight: 400;
	}

	h1 {
		font-size: 1.5em;
	}

	a.button {
		color: #fff;
		border-radius: 100px;
		background: #01b6e2;
		border: none;
		font-size: 1.2em;
		padding: 0.5em 2em;
		margin: 0.5em;
	}
	.google-map-btn {
		display: flex;
		align-items: center;
		padding: 5px 10px;
		background-color: #eeeeee;
		border-radius: 23px;
		font-size: 12px;
		margin-left: 20px;
		img {
			width: 18.45px;
			margin-right: 5px;
		}
	}
	.public-transportation {
		td {
			font-size: 13.63px;
			line-height: 1.2;
			color: #000;
			background-color: #f0fbfe;
			padding: 14.5px 9px;
			border: 1px solid black;
		}
	}

	iframe {
		background: #aaa;
		@media screen and (min-width: 600px) {
			&.mobile {
				display: none;
			}
		}
		@media screen and (max-width: 599px) {
			&.desktop {
				display: none;
			}
		}
	}
}
@media screen and (min-width: 768px) {
	.right {
		padding-bottom: 100px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/map_split2_about_info.vue